export default [
    {
        path: '/request/unit-replacements',
        name: 'request-unit-replacements',
        props: true,
        component: () => import('@/views/request/unit-replacements/index.vue'),
        meta: {
            pageTitle: 'Penggantian Unit',
            breadcrumb: [
                {
                text: 'Penggantian Unit',
                active: true,
                },
            ],
        },
    },
    {
        path: '/request/unit-replacement/:id',
        name: 'detail-unit-replacement',
        props: true,
        component: () => import('@/views/request/unit-replacements/detail.vue'),
        meta: {
            pageTitle: 'Penggantian Unit',
            breadcrumb: [
                {
                text: 'Penggantian Unit',
                to: { name: 'request-unit-replacements' },
                },
                {
                text: 'Detail Penggantian Unit',
                active: true,
                },
            ],
        },
    },
]